import type { ILink } from './types';

import { Link as CkLink } from '@chakra-ui/next-js';

const Link: ILink = ({ children, ...props }) => {
  return <CkLink {...props}>{children}</CkLink>;
};

export default Link;
